import Motion, { type MotionProps } from '@/app/components/Motion';

import type { SectionContentProps } from './SectionContent';
import Time from './Time';

export interface SectionContentTimeProps
  extends Pick<SectionContentProps, 'Icon' | 'time' | 'variant'> {
  readonly isActive: boolean;
}

export const getMotionProps = ({
  isActive,
}: {
  isActive: boolean;
}): MotionProps => ({
  animate: {
    opacity: isActive ? 1 : 0,
    transitionEnd: {
      opacity: isActive ? 1 : 0,
    },
  },
  initial: {
    opacity: isActive ? 1 : 0,
  },
  transition: {
    duration: 1,
  },
});

const SectionContentTime = ({
  Icon,
  isActive,
  time,
  variant,
}: SectionContentTimeProps): JSX.Element => {
  const motionProps = getMotionProps({ isActive });
  return (
    <Motion {...motionProps} className="relative z-20 mb-8 hidden lg:block">
      <Time Icon={Icon} time={time} variant={variant} />
    </Motion>
  );
};

export default SectionContentTime;
